import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PoiEducationIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.5337 2.30812L5.0015 2L4.4663 2.30812L1.5332 4.00075L1 4.30987L1.5332 4.61798L2.02038 4.90109V7.83019H2.11442V7.84019H7.88558V4.95311L8.4668 4.61798L9.003 4.30987L5.5337 2.30812ZM5.0015 6.61873L7.35238 5.26122V7.30199H2.55058V5.2012L4.4633 6.30161L5.0015 6.61873ZM7.90259 4.32587L7.88258 4.33688L7.35238 4.64499L5.0015 6.0015L2.55358 4.58997L2.10041 4.32587L2.0724 4.30987L5.0015 2.61623L7.9326 4.30987L7.90259 4.32587Z" />
        </SvgIcon>
    );
};
